// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S6xR","label":"styles_label__3-CX6"};